import React from "react";
import { Outlet } from "react-router-dom";

const Createpassword = React.lazy(() => import("@pages/create-password/index"));
const Login = React.lazy(() => import("@pages/login/index"));
const RedirectToHome = React.lazy(() => import("@components/RedirectToHome"));
const LoginAdmin = React.lazy(() => import("@pages/admin/login/index"));
const BusinessLogin = React.lazy(() => import("@pages/business/login/index"));
const NormalUserRegister = React.lazy(() => import("@pages/register/index"));
const BusinessUserRegister = React.lazy(() => import("@pages/business/register/index"));
const VerifyEmail = React.lazy(() => import("@pages/verify-email/index"));
const ForgotPassword = React.lazy(() =>import("@pages/forgot-password/index"));
const ChangePassword = React.lazy(() =>import("@pages/account/change-password/index"));

export const authRoutes = [
  {
    caseSensitive: true,
    path: "/create-password",
    element: <Createpassword />,
  },
  {
    element: (
      <RedirectToHome>
        <Outlet />
      </RedirectToHome>
    ),
    children: [
      {
        caseSensitive: true,
        path: "/business/login",
        element: <BusinessLogin />,
      },
      {
        caseSensitive: true,
        path: "/login",
        element: <Login />,
      },
      {
        caseSensitive: true,
        path: "/admin/login",
        element: <LoginAdmin />
      },
      {
        caseSensitive: true,
        path: "/business/register",
        element: <BusinessUserRegister />
      },
      {
        caseSensitive: true,
        path: "/register",
        element: <NormalUserRegister />
      },
      {
        caseSensitive: true,
        path: "/verify-email",
        element: <VerifyEmail />
      },
      {
        caseSensitive: true,
        path: "/forgot-password",
        element: <ForgotPassword />
      },
    ],
  },
  {
    caseSensitive: true,
    path: "/change-password",
    element: <ChangePassword />
  },
];
